import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { ProductZakupFilter, ProductZakupState, RegisterDocsFilter } from './types';

const today = dayjs().format('YYYY-MM-DD');
const oneWeekAge = dayjs().subtract(1, 'week').format('YYYY-MM-DD');

export const defaultProductZakupFilter: ProductZakupFilter = {
  Start: oneWeekAge,
  Finish: today,
};

export const defaultRegisterFilter: RegisterDocsFilter = {
  Start: oneWeekAge,
  Finish: today,
};

export const initialState: ProductZakupState = {
  filter: defaultProductZakupFilter,
  filterRegisterDocs: defaultRegisterFilter,
};

const purchaseSlice = createSlice({
  name: 'purchase',
  initialState,
  reducers: {
    setProductZakupFilter: (state, { payload }) => {
      state.filter = payload;
    },
    setRegisterDocsFilter: (state, { payload }) => {
      state.filterRegisterDocs = payload;
    },
  },
});

export const { setProductZakupFilter, setRegisterDocsFilter } = purchaseSlice.actions;
export default purchaseSlice.reducer;
